/**
 * API client utilities
 */

const API_BASE = '/api';

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Make an authenticated API request
 */
export async function apiRequest<T>(
  method: string,
  path: string,
  data?: any,
  sessionId?: string | null
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (sessionId) {
    headers['Authorization'] = `Bearer ${sessionId}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  });

  const json = await response.json();

  if (!response.ok) {
    throw new ApiError(response.status, json.error || 'Request failed');
  }

  return json.data;
}

/**
 * API client with helper methods
 */
export const api = {
  get: <T>(path: string, sessionId?: string | null) =>
    apiRequest<T>('GET', path, undefined, sessionId),
  
  post: <T>(path: string, data?: any, sessionId?: string | null) =>
    apiRequest<T>('POST', path, data, sessionId),
  
  patch: <T>(path: string, data?: any, sessionId?: string | null) =>
    apiRequest<T>('PATCH', path, data, sessionId),
  
  delete: <T>(path: string, sessionId?: string | null) =>
    apiRequest<T>('DELETE', path, undefined, sessionId),
};
